import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { deletePlayer } from '../../services'

interface UseMutationDeletePlayerProps {
	id: string
}

export default function useMutationDeletePlayer(
	props?: UseBaseMutationOptions<void, UseMutationDeletePlayerProps>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.DeletePlayer],
		mutationFn: ({ id }) => deletePlayer(id),
		...props,
	})
}
